<template>
    <div>

      <default-index v-if="type==='1'" ref="defaultIndex"
                    :pri_detail="{
                          activityObj:{bank_center_id:bank_center_id,province_id:province_id,city_id:city_id,county_id:county_id,station_id:station_id,di_uuid:di_uuid},
                       }">

      </default-index>
      <default-index1 v-if="type==='2'" ref="defaultIndex1"
                    :pri_detail="{
                          activityObj:{bank_center_id:bank_center_id,province_id:province_id,city_id:city_id,county_id:county_id,station_id:station_id,di_uuid:di_uuid},
                       }">

      </default-index1>
<!--      <example7 v-if="type==='2'"></example7>-->
    </div>
</template>

<script>
import defaultIndex from "@/components/views/bankPlatform/deviceIndex/defaultIndex";
import defaultIndex1 from "@/components/views/bankPlatform/deviceIndex/defaultIndex_1";
// import example7 from "@/components/index/right/Example7";

export default {
name: "LoginDevice",
  components: {
  defaultIndex ,
  defaultIndex1 ,
    // example7
  },
  data() {
    return {
      bank_center_id:'',
      province_id:'',
      city_id:'',
      county_id:'',
      station_id:'',
      type:'1',
      di_uuid:'',
    }
  },
  created: function() {
    console.info("query:"+JSON.stringify(this.$route.query));
    let bank_center_id = this.$route.query.bank_center_id;
    let province_id = this.$route.query.province_id;
    let city_id = this.$route.query.city_id;
    let county_id = this.$route.query.county_id;
    let station_id = this.$route.query.station_id;
    let type = this.$route.query.type;
    let di_uuid = this.$route.query.di_uuid;
    if(bank_center_id!==undefined){
      this.bank_center_id = bank_center_id;
    }
    if(province_id!==undefined){
      this.province_id = province_id;
    }
    if(city_id!==undefined){
      this.city_id = city_id;
    }
    if(county_id!==undefined){
      this.county_id = county_id;
    }
    if(station_id!==undefined){
      this.station_id = station_id;
    }
    if(type!==undefined){
      this.type = type;
    }
    if(di_uuid!==undefined){
      this.di_uuid = di_uuid;
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/LoginDevice.vue